import css from 'styled-jsx/css';
import { pageWidth } from 'styles/css-constants';

/*
The Column is designed to work with two other Column bundles to form three, centered columns of teasers
*/
export default css`
  .Spread--column {
    flex-direction: column;
    padding: 0 0.5rem;
  }

  .Spread__cake {
    flex-wrap: wrap;
    flex: 0 0 100%;
    max-width: 100%;
  }

  .Spread__item--teaser {
    margin-bottom: 1.5rem;
  }

  .Spread__items {
    flex-direction: column;
  }

  .Spread__title {
    width: 100%;
    margin-right: 0;
    margin-left: 0;
  }

  @media (max-width: 63.99rem) {
    .Spread__cake-name img {
      max-width: 100px;
    }
  }

  @media (min-width: 48rem) {
    .Spread--column {
      display: flex;
      padding: 0;
    }

    .Spread__description,
    .Spread__link,
    .Spread__title {
      margin-right: 0;
      margin-left: 0;
    }

    .Spread__items {
      display: flex;
    }

    .Spread__link {
      order: 4;
    }

    .Spread__title {
      align-items: flex-end;
      height: 4.5rem;
    }
  }

  @media (min-width: 64rem) {
    .Spread--column {
      width: calc((${pageWidth.large} - 3rem) / 3);
    }

    .Spread__item--teaser {
      flex: 0 0 auto;
    }

    .Spread__items {
      width: auto;
    }

    .Spread__title {
      height: 4rem;
    }
  }

  @media (min-width: 75rem) {
    .Spread--column {
      width: calc((${pageWidth.midlarge} - 3rem) / 3);
    }

    .Spread__items {
      width: auto;
    }
  }

  @supports (display: grid) {
    @media (min-width: 64rem) {
      .Spread__items {
        width: auto;
      }
    }

    @media (min-width: 75rem) {
      .Spread__items {
        width: auto;
      }
    }
  }
`;
